import { FATCATaxResidencyEntry } from '../utils/useFATCATaxResidencies';

export const validateFATCATaxResidenciesTextReasons = async (
  fatcaTaxResidencies: FATCATaxResidencyEntry[],
): Promise<{ status: string; entries: FATCATaxResidencyEntry[] }> => {
  await new Promise<void>((resolve) => {
    setTimeout(() => {
      resolve();
    }, 1000);
  });

  return { status: 'success', entries: fatcaTaxResidencies };
};
